
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","viewBox":"20 9 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40.208 21h-6.303l-.523 2.933 5.69.007c2.802 0 3.628 1.023 3.605 2.716-.014.868-.388 2.338-.55 2.815-.432 1.27-1.319 2.717-4.644 2.713l-5.531-.003-.521 2.937h6.29c2.219 0 3.16-.261 4.162-.722 2.215-1.033 3.534-3.228 4.063-6.093.785-4.268-.193-7.303-5.738-7.303z","fill":"#008DE4"}}),_c('path',{attrs:{"d":"M31.184 26.585c-1.652 0-1.889 1.08-2.044 1.734-.205.854-.273 1.203-.273 1.203h6.455c1.653 0 1.89-1.08 2.044-1.734.206-.854.273-1.203.273-1.203h-6.455z","fill":"#008DE4"}})])
          )
        }
      }
    